import { put } from 'redux-saga/effects';
import { markHomeStartVideoApi } from 'common/api/videos';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import i18next from 'i18next';
import { updateHomeStartVideoAction } from 'components/mark-unmark-start-home-video';

export function* markHomeStartVideoEffect({ payload: { video } }) {
  try {
    yield markHomeStartVideoApi(video.id);
    yield put(updateHomeStartVideoAction(video.id));
    yield put(
      reduxNotificationAction(
        i18next.t('mark_home_start_video_notification_success'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.SUCCESS
      )
    );
  } catch (error) {
    yield put(
      reduxNotificationAction(
        i18next.t('mark_channel_start_video_notification_error'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.ERROR
      )
    );
  }
}
